export const MAGIC_WINDOW_LOADED = 'MAGIC_WINDOW_LOADED'
export const MAGIC_WINDOW_CLOSE = 'MAGIC_WINDOW_CLOSE'
export const MAGIC_WINDOW_GA_TRACKING = 'MAGIC_WINDOW_GA_TRACKING'
export const MAGIC_WINDOW_FULL_SCREEN = 'MAGIC_WINDOW_FULL_SCREEN'
export const MAGIC_WINDOW_MODAL_SCREEN = 'MAGIC_WINDOW_MODAL_SCREEN'
